import { render, staticRenderFns } from "./periodeset.vue?vue&type=template&id=cfe93a46"
import script from "./periodeset.vue?vue&type=script&lang=js"
export * from "./periodeset.vue?vue&type=script&lang=js"
import style0 from "./periodeset.vue?vue&type=style&index=0&id=cfe93a46&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports